import {
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATION:
      return { ...state, loading: true };
    case GET_LOCATION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_LOCATION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getLocationReducer;
